import { createSlice, current } from '@reduxjs/toolkit';
import { addCategory, deleteCategoryById, fetchCategory, updateCategoryById } from './categoryThunk';

import { toast } from 'react-toastify';
import { API_STATUS_TYPE } from '../../../utils/contants';

const INITAL_STATE = {
  isLoading: false,
  categories: null,
  status: 'idle',
  currentCategory: null,
  categoryDetails: null,
  error: null
};

const categorySlice = createSlice({
  name: 'category',
  initialState: INITAL_STATE,
  reducers: {
    clearSelectedCategory: (state, action) => {
      state.currentCategory = null;
    },
    selectedCategory: (state, action) => {
      state.currentCategory = action.payload;
    },
    updateCategory: (state, action) => {
      const updatedCategory = action.payload;
      const index = state.categories.findIndex((category) => category.id === updatedCategory.id);

      if (index !== -1) {
        // .splice(startIndex, deleteCount, itemToInsert)
        state.categories.splice(index, 1, {
          ...state.categories[index],
          ...updatedCategory
        });
      }
    }
  },
  extraReducers: (builder) => {
    builder

      //Handling Add Category API Response
      .addCase(addCategory.pending, (state, action) => {
        state.isLoading = true;
        state.status = API_STATUS_TYPE.PENDING;
      })
      .addCase(addCategory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
        // toast.success(`${menuName} has been added to the dashboard!`);
      })

      //Handling Fetching Category API Response
      .addCase(fetchCategory.pending, (state, action) => {
        state.isLoading = true;
        state.status = API_STATUS_TYPE.PENDING;
      })
      .addCase(fetchCategory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;

        // 1. Process categories with the translationsMap
        const processedCategories = action.payload.data.map((item) => ({
          ...item,
          translationsMap: Array.isArray(item.translations)
            ? item.translations.reduce((acc, t) => {
                if (t && t.languageCode) {
                  acc[t.languageCode] = {
                    name: t.name ?? '',
                    description: t.description ?? ''
                  };
                }
                return acc;
              }, {})
            : {}
        }));

        // 2. Set the categories array for list rendering
        state.categories = processedCategories;

        // 3. Normalize categoryDetails into a single lookup object
        // Result: { "1": {id: 1, ...}, "2": {id: 2, ...} }
        state.categoryDetails = processedCategories.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {});
      })

      //Deleting the category by category ID
      .addCase(deleteCategoryById.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(deleteCategoryById.fulfilled, (state, action) => {
        state.isLoading = false;
      })

      // Update category by category id
      .addCase(updateCategoryById.pending, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.PENDING;
      })
      .addCase(updateCategoryById.fulfilled, (state, action) => {
        state.isLoading = true;
        state.status = API_STATUS_TYPE.SUCCESSED;
      })

      .addMatcher(
        (action) => action.type.endsWith('/rejected'),
        (state, action) => {
          state.error = action?.payload?.error;
        }
      );
  }
});

export const { clearSelectedCategory, selectedCategory, updateCategory } = categorySlice.actions;
export default categorySlice.reducer;
